import { createSlice } from "@reduxjs/toolkit";
import { getAuditTrailList } from "./_auditTrailAction";


interface ManageAuditTrailState {
  auditTrailList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number
}

const initialState: ManageAuditTrailState = {
  auditTrailList: [],
  loading: false,
  error: null,
  totalCount: 0
};


export const auditTrailReducer = createSlice({
  name: "auditTrail",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Audit Trail List
      .addCase(getAuditTrailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAuditTrailList.fulfilled, (state, action) => {        
        state.loading = false;
        state.auditTrailList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getAuditTrailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = auditTrailReducer.actions;
export default auditTrailReducer;